var map = {
	"./penguin 2.jpg": 22547,
	"./penguin.jpg": 46657,
	"./rabbit  4.jpg": 18989,
	"./rabbit 01.jpg": 37956,
	"./rabbit 07.jpg": 87954,
	"./rabbit 08.jpg": 70665,
	"./rabbit 09.jpg": 72876,
	"./rabbit 6.jpg": 15619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54927;